import { styled, Button as MuiButton, ButtonProps } from "@mui/material";

const StyledButton = styled(MuiButton)<ButtonProps>(({ theme }) => ({
	// color: theme.palette.getContrastText(purple[500]),
	// backgroundColor: purple[500],
	// "&:hover": {
	// 	backgroundColor: purple[700],
	// },
}));

export const Button = (props: any) => {
	const {
		name = "button",
		variant = "contained" || "outlined" || "text",
		disabled,
		color,
		onClick,
		size = "large",
		startIcon,
		endIcon,
		
	} = props;
	return (
		<StyledButton
			
			variant={variant}
			disabled={disabled}
			color={color}
			onClick={onClick}
			size={size}
			// Icon with button props...
			startIcon={startIcon}
			endIcon={endIcon}
			{...props}
		>
			{name}
		</StyledButton>
	);
};